import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { APP_LINKS } from '@/helpers/links';
import LoanTermsVersion01 from './versions/v1';
import LoanTermsVersion02 from './versions/v2';
import LoanTermsVersion03 from './versions/v3';
import LoanTermsVersion04 from './versions/v4';
import LoanTermsVersion05 from './versions/v5';
import { TARIFF_PLANS as PLANS_V3 } from './versions/v3/constants';
import { TARIFF_PLANS as PLANS_V4 } from './versions/v4/constants';
import { TARIFF_PLANS as PLANS_V5 } from './versions/v5/constants';

const VERSIONS = ['v1', 'v2', 'v3', 'v4', 'v5'];
const LATEST_VERSION = VERSIONS[VERSIONS.length - 1];

const VERSION_PLANS = {
  v3: Object.values(PLANS_V3),
  v4: Object.values(PLANS_V4),
  v5: Object.values(PLANS_V5),
};

const LoanTermsPlansPage = () => {
  const { version } = useParams();
  const [searchParams] = useSearchParams();
  const plan = searchParams.get('plan') || PLANS_V5.standard;
  const resolvedVersion = version || LATEST_VERSION;

  if (version && !VERSIONS.includes(version)) {
    return <Navigate to={APP_LINKS.loanTermsPlans()} replace />;
  }

  const allowedPlans = VERSION_PLANS[resolvedVersion];
  if (allowedPlans && !allowedPlans.includes(plan)) {
    return <Navigate to={APP_LINKS.loanTermsPlans()} replace />;
  }

  switch (version) {
    case 'v1':
      return <LoanTermsVersion01 />;
    case 'v2':
      return <LoanTermsVersion02 />;
    case 'v3':
      return <LoanTermsVersion03 plan={plan} />;
    case 'v4':
      return <LoanTermsVersion04 plan={plan} />;
    case 'v5':
    default:
      return <LoanTermsVersion05 plan={plan} />;
  }
};

export default LoanTermsPlansPage;